// extracted by mini-css-extract-plugin
module.exports = {"gnzs-1c-amo--order-modal-body":"index_gnzs-1c-amo--order-modal-body_p577W","tab":"index_tab_1tBvo","bigWrapper":"index_bigWrapper_20neV"};